import { onBeforeUnmount, ref, watch, type Ref } from "vue";

type MaybeRefBool = Ref<boolean>;

export function useLazyMount(visible: MaybeRefBool, unmountDelayMs = 250) {
  const mounted = ref(visible.value);
  let timer: ReturnType<typeof setTimeout> | null = null;

  const clear = () => {
    if (!timer) return;
    clearTimeout(timer);
    timer = null;
  };

  watch(
    visible,
    (isVisible) => {
      if (isVisible) {
        clear();
        mounted.value = true;
        return;
      }

      clear();
      timer = setTimeout(() => {
        mounted.value = false;
        timer = null;
      }, unmountDelayMs);
    },
    { immediate: true }
  );

  onBeforeUnmount(() => {
    clear();
  });

  return { mounted };
}

